// extracted by mini-css-extract-plugin
export default {"title":"InputRadio_title__mc3AA","option":"InputRadio_option__3QSxB","radio":"InputRadio_radio__zFhyy"};